module.exports = __webpack_public_path__ + "schemax22.9eaaa42.jpg";